/// <reference path='../../core/services/resource.service.ts'/>
'use strict';

namespace Core {

    export class Culture {
        public constructor(cultureCode: string, titleResource: string) {
            this.CultureCode = cultureCode;
            this.TitleResource = titleResource;
        }
        CultureCode: string;
        TitleResource: string;
    }

    export class Location {
        public constructor(
            domainId: number,
            titleResource: string,
            cultures: Culture[],
            countryCode: string
        ) {
            this.DomainId = domainId;
            this.TitleResource = titleResource;
            this.Cultures = cultures;
            this.CountryCode = countryCode;
        }
        DomainId: number;
        TitleResource: string;
        Cultures: Culture[] = [];
        CountryCode: string;
    }

    export class Settings {
        public constructor(domainId: number, cultureCode: string) {
            this.DomainId = domainId;
            this.CultureCode = cultureCode;
        }
        DomainId: number;
        CultureCode: string;
    }

    class LocationSettings {

        // bound
        onClose: () => void;

        private locations: Location[];
        private cultures: Culture[];
        private model: Settings;

        constructor (
            private languageService: any,
            private $scope: ng.IScope,
            private $route: ng.route.IRouteService,
            private $q: ng.IQService,
            private cookieService: any,
            private $location: ng.ILocationService,
        ) {
        }

        public init (element: ng.IAugmentedJQuery): void {

            this.getLocations().then((options: Location[]) => {
                const regions = TRPCONFIG.Domain.EnabledRegionOnLangSelector.split(',');
                const newOptions = regions && regions.length > 0 && regions.map(region => {
                    return options.filter((op) => op.CountryCode === region);
                }).flat() || [];
                const doNotApplyConfigForThisDomainSuffix = TRPCONFIG.Domain.EnabledRegionOnLangSelectorOverride;
                const domainHost = this.$location.host();
                const domainMatch = domainHost && domainHost.endsWith(doNotApplyConfigForThisDomainSuffix);
                this.locations = domainMatch ? options : newOptions;

                let culture = this.cookieService.get('LANG') || TRPCONFIG.Domain.CultureCode;
                if (/^[a-z]{2}-[a-z]{2}$/i.test(culture)) {
                    culture = culture.substr(0,3) + culture.substr(3,5).toUpperCase();
                }
                this.model = new Settings(TRPCONFIG.Domain.DomainId, culture );
            });

            // watch selected location
            this.$scope.$watch('ls.model.DomainId', (val, old) => {
               if (!_.isUndefined(val)) {
                    this.onSetLocation(val);
               }
            });
        }

        private getLocations(): ng.IPromise<any> {

            // Options will remain hardcoded for now, but we will mock a service response.
            let deferred = this.$q.defer();

            let response: Location[] = [
                new Location(
                    34,
                    'DISPLAYUNITEDARABEMIRATES',
                    [
                        new Culture('ar-AE', 'DISPLAYARABIC'),
                        new Culture('en-BZ', 'DISPLAYENGLISH')
                    ],
                    'AE'
                ),
                new Location(
                    35,
                    'DISPLAYSAUDIARABIA',
                    [
                        new Culture('ar-SA', 'DISPLAYARABIC'),
                        new Culture('en-TT', 'DISPLAYENGLISH')
                    ],
                    'SA'
                )
            ];

            deferred.resolve(response);
            return deferred.promise;
        }

        private onSetLocation(domainId) {
            let matchLocation: Location = _.find(this.locations, (location: Location) => {
                return location.DomainId === domainId;
            });

            // Get cultures for this location
            this.cultures = matchLocation.Cultures;

            // Attempt to match previous selected culture
            let matchCulture: Culture = _.find(this.cultures, (culture: Culture) => {
                return culture.CultureCode === this.model.CultureCode;
            });

            if (!matchCulture) {
                // select the first culture option
                this.model.CultureCode = this.cultures[0].CultureCode;
            }
        }

        public handleLocationClick(event, location: Location) {
            this.setDomain(location.DomainId);
        }

        public handleLocationKeydown(event, location: Location) {
            event.keyCode === TR.KeyCode.SPACE && this.setDomain(location.DomainId);
        }

        public handleCultureClick(event, culture: Culture) {
            this.setCulture(culture.CultureCode);
        }

        public handleCultureKeydown(event, culture: Culture) {
            event.keyCode === TR.KeyCode.SPACE && this.setCulture(culture.CultureCode);
        }

        public setDomain(domainId) {
            this.model.DomainId = domainId;
        }

        public setCulture(cultureCode) {
            this.model.CultureCode = cultureCode;
        }

        public save() {
            this.languageService.setLanguage(this.model.CultureCode, this.model.DomainId).then(() => {
                if (TRPCONFIG.Domain.RedirectLanguageChangeToHomepage &&
                    TRPCONFIG.Domain.DomainId !== Number(this.model.DomainId)) {
                   window.location.href = '/?rl=1';
               }
               else {
                   window.location.href = this.$location.absUrl();
               }
            });
        }
    }

    angular
        .module('core')
        .directive('locationSettings', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                replace: false,
                transclude: false,
                controller: LocationSettings,
                controllerAs: 'ls',
                bindToController: {
                    onClose: '&',
                },
                templateUrl: `partials/home/directivetemplate?type=LocationSettings`,
                link: (
                    scope : ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller: LocationSettings
                ) => {
                    controller.init(el);
                }
            };
        });
}
